<template>
    <div style="width: 100%;height: 100%;display: flex;">
        <div style="width: 320px">
            <div class="gradualChange">
                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "platformHome"
    }
</script>

<style scoped>
.gradualChange{background: url("/img/rusticate/gradualChange.png");height: 100%;width: 100%;}
</style>
